import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IdentityResult } from '@app/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private http: HttpClient,
  ) { }

  public getMyInfo() {
    return this.http.get(`${environment.apiUrl}api/customerprofile/me`);
  }

  public updateProfile(data) {
    return this.http.put(`${environment.apiUrl}api/customerprofile/update`, data);
  }

  public updateAvatar(data) {
    return this.http.post(`${environment.apiUrl}api/customerprofile/profileimage`, data);
  }

  public removeAvatar() {
    return this.http.delete(`${environment.apiUrl}api/customerprofile/profileimage`);
  }

  public updateEmail(data) {
    return this.http.post(`${environment.apiUrl}api/account/changeemail`, data);
  }

  public updatePhone(data) {
    return this.http.post(`${environment.apiUrl}api/account/changephone`, data);
  }

  public updatePassword(data) {
    return this.http.post(`${environment.apiUrl}api/account/resetpassword`, data);
  }

  public deleteProfile(data) : Observable<IdentityResult> {
    return this.http.delete<IdentityResult>(`${environment.apiUrl}api/customerprofile/deleteprofile?password=${data}`);
  }
}
